import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {AdendaDTO} from '../../../models/dtos/AdendaDTO';

@Component
({
  selector: 'app-adenda',
  templateUrl: './adenda.component.html',
  styleUrls: ['./adenda.component.scss']
})
export class AdendaComponent implements OnInit
{
  @Input()
  adendaDTO: AdendaDTO;

  @Input()
  parentFormGroup: FormGroup;

  constructor()
  {

  }

  ngOnInit()
  {

  }

  get adendaControl(): AbstractControl
  {
    return this.parentFormGroup.get('adendaControl');
  }
}
